<template>
	<div class="pdf-viewer-container" :id="getId">
		<PDFViewer
			v-bind="{url}"
			@document-errored="onDocumentErrored"
			:fullscreen-callback="fullscreenMe"
			:fullscreen-close-callback="fullscreenClose"
			:show-fullscreen-btn="!isMobile">
		</PDFViewer>
	</div>
</template>


<script>
	import { mapState } from 'vuex'
	import PDFViewer from '@/components/ui/_global/viewer/PDFViewer.vue'

	export default {
		name: 'sila-pdf-viewer',

		components: {
			PDFViewer,
		},

		props: {
			url: {
				type: String,
				required: true,
				default: ''
			},

			id: {
				type: String,
				required: true,
				default: ''
			},
		},

		data() {
			return {
				documentError: undefined,
				enableUploader: false, // process.env.VUE_APP_UPLOAD_ENABLED === 'true',
			};
		},

		computed: {
			...mapState({
				isMobile: state => state.mobile.mobile
			}),

			getId() {
				return "preview_" + this.id
			}
		},

		methods: {
			onDocumentErrored(e) {
				this.documentError = e.text;
			},

			fullscreenMe () {
				var elem = document.querySelector('#' + this.getId);
				
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.mozRequestFullScreen) { /* Firefox */
					elem.mozRequestFullScreen();
				} else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
					elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) { /* IE/Edge */
					elem.msRequestFullscreen();
				}
			},

			fullscreenClose() {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) { /* Firefox */
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) { /* IE/Edge */
					document.msExitFullscreen();
				}
			}
		},

	}
</script>


<style scoped lang="scss">
	.pdf-viewer-container {
		height: 450px;
	}
</style>